import { render, staticRenderFns } from "./type-subscript.mpx?vue&type=template&id=4f9e2576&scoped=true&component=true&componentId=type-subscript3ef92790"
import script from "./type-subscript.mpx?vue&type=script&lang=js&component=true&componentId=type-subscript3ef92790"
export * from "./type-subscript.mpx?vue&type=script&lang=js&component=true&componentId=type-subscript3ef92790"
import style0 from "./type-subscript.mpx?vue&type=style&index=0&id=4f9e2576&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m3ef92790%22%7D&component=true&componentId=type-subscript3ef92790"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9e2576",
  null
  
)

export default component.exports